import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { BILLING_TYPE } from '../../../state/invoice/InvoiceBillingType';

class InvoiceCreatedEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            proposal: nextProps.proposal || null,
        })
    }

    render() {
        return <div className={"row " + this.state.className}>
            <div className="col-12">
                {this.state.object.attributes.billingType !== BILLING_TYPE.RETURN ? <FormattedMessage
                    id="invoice.analytics.events.invoice_created_text"
                    defaultMessage="Invoice {identifier} has been created"
                    values={{
                        identifier: this.state.object.attributes.identifier
                    }}
                /> : <FormattedMessage
                    id="invoice.analytics.events.return_created_text"
                    defaultMessage="Return {identifier} has been created"
                    values={{
                        identifier: this.state.object.attributes.identifier
                    }}
                />}
            </div>
        </div>
    }

}

export default InvoiceCreatedEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/invoice-created.component.jsx